function epochFromIbkrDayKey(ibkrDayKey) {
  if (typeof ibkrDayKey !== 'string' || !/^\d{8}$/.test(ibkrDayKey)) return null
  const y = Number(ibkrDayKey.slice(0, 4))
  const m = Number(ibkrDayKey.slice(4, 6))
  const d = Number(ibkrDayKey.slice(6, 8))
  if (!Number.isInteger(y) || !Number.isInteger(m) || !Number.isInteger(d)) return null
  if (y < 1900 || m < 1 || m > 12 || d < 1 || d > 31) return null
  const epochMs = Date.UTC(y, m - 1, d)
  const dt = new Date(epochMs)
  if (
    dt.getUTCFullYear() !== y
    || dt.getUTCMonth() !== m - 1
    || dt.getUTCDate() !== d
  ) {
    return null
  }
  return Math.floor(epochMs / 1000)
}

function dayKeyFromUtcMidnightMs(rawEpochMs) {
  if (!Number.isFinite(rawEpochMs)) return null
  const dt = new Date(rawEpochMs)
  if (
    dt.getUTCHours() !== 0
    || dt.getUTCMinutes() !== 0
    || dt.getUTCSeconds() !== 0
    || dt.getUTCMilliseconds() !== 0
  ) {
    return null
  }
  const y = dt.getUTCFullYear()
  const m = String(dt.getUTCMonth() + 1).padStart(2, '0')
  const d = String(dt.getUTCDate()).padStart(2, '0')
  if (y < 1900 || y > 9999) return null
  return `${y}${m}${d}`
}

export function resolveCarsBarDayKey(bar) {
  if (typeof bar?.ibkrDayKey === 'string' && /^\d{8}$/.test(bar.ibkrDayKey)) {
    return bar.ibkrDayKey
  }
  return dayKeyFromUtcMidnightMs(Number(bar?.rawEpochMs))
}

function toEngineBar(bar) {
  const time = epochFromIbkrDayKey(resolveCarsBarDayKey(bar))
  if (time == null) return null
  const open = Number(bar.open)
  const high = Number(bar.high)
  const low = Number(bar.low)
  const close = Number(bar.close)
  const volume = Number(bar.volume)
  if (![open, high, low, close, volume].every(Number.isFinite)) return null
  return { time, open, high, low, close, volume }
}

export function alignCarsPrimaryBarsToChartBars(chartBars, adjustedPrimaryBars) {
  const adjustedByDayKey = new Map()
  for (const bar of Array.isArray(adjustedPrimaryBars) ? adjustedPrimaryBars : []) {
    const key = resolveCarsBarDayKey(bar)
    if (key) adjustedByDayKey.set(key, bar)
  }

  const alignedPrimaryBars = []
  const alignedChartBars = []
  for (const chartBar of Array.isArray(chartBars) ? chartBars : []) {
    const key = resolveCarsBarDayKey(chartBar)
    if (!key) continue
    const adjustedBar = adjustedByDayKey.get(key)
    if (!adjustedBar) continue
    alignedPrimaryBars.push(adjustedBar)
    alignedChartBars.push(chartBar)
  }

  return { alignedPrimaryBars, alignedChartBars }
}

export function buildCarsIndicatorPayload(primaryDailyBars, benchmarkBars) {
  return {
    bars: (Array.isArray(primaryDailyBars) ? primaryDailyBars : [])
      .map(toEngineBar)
      .filter(Boolean),
    bar_size: '1 day',
    application_snapshot: { asset_class: 'equity', preset_params: {} },
    enabled_indicators: ['cars_v1'],
    benchmark_bars_by_symbol: {
      SPY: (Array.isArray(benchmarkBars) ? benchmarkBars : [])
        .map(toEngineBar)
        .filter(Boolean),
    },
  }
}
